import React, { useState } from 'react';
import cn from 'classnames';
import currency from 'currency.js';
import useAddons from '../../../hooks/useAddons';
import { addonUnitPrice } from '../../../utils/functions';
import { AddonSheet } from '../../../models';
import { addonSheetToSheet } from '../MultiPose/functions';
import DisplayableSheet from '../MultiPose/DisplayableSheet';
import styles from './IndividualPrintsBuilder.module.scss';
import IncrementalButton from './IncrementalButton';
import Button from '../../Button/v2';
import {
  getAppropriateBg,
  getAppropriateForeground,
} from '../../_pages/_ElementaryMultiPose/MultiPosePackageBuilder/steps/FavoritePoseSelection';

export default function Builder({
  useRetouching = false,
  packagePoses = [],
  background,
  backgrounds,
  isElementary = true,
  isLoading,
  orderPackage = null,
  pose,
  onConfirm,
  onCancelProps = {},
}) {
  const displayCancelButton = Object.keys(onCancelProps).length > 0;

  const { data: addons, isLoading: isLoadingAddons } = useAddons(isElementary);
  const [printBuilderCart, setPrintBuilderCart] = useState({});

  const handleDecrement = (addonId) => {
    const currValue = printBuilderCart[addonId] ? printBuilderCart[addonId] : 0;
    setPrintBuilderCart((prev) => ({ ...prev, [addonId]: Math.max(currValue - 1, 0) }));
  };

  const handleIncrement = (addonId) => {
    const currValue = printBuilderCart[addonId] ? printBuilderCart[addonId] : 0;
    setPrintBuilderCart((prev) => ({ ...prev, [addonId]: currValue + 1 }));
  };

  const sheets = addons.map((addon) => {
    const foreground = getAppropriateForeground(packagePoses, pose);

    return addonSheetToSheet(new AddonSheet({ addon, background, pose, foreground }));
  });

  const totalItems = Object.keys(printBuilderCart).reduce((acc, cur) => acc + printBuilderCart[cur], 0);
  const isEmpty = totalItems === 0;

  const handleConfirm = () => {
    const addonSheets = Object.keys(printBuilderCart).map((id) => {
      const bg = getAppropriateBg(packagePoses, pose, backgrounds);
      const foreground = getAppropriateForeground(packagePoses, pose);

      return new Array(printBuilderCart[id]).fill(null).map(() => ({
        addon: addons.find((addon) => addon.id.toString() === id.toString()),
        addonId: id,
        background: bg,
        backgroundId: bg?.id,
        pose,
        poseId: pose.id,
        foreground,
        foregroundId: foreground?.id,
      }));
    }).flat();

    onConfirm(addonSheets, []);
  };

  if (isLoadingAddons) return null;

  return (
    <>
      <div className={cn(styles.container, { [styles.cancelBtn]: displayCancelButton })}>
        {sheets.map((sheet) => (
          <div key={sheet.addon.id} className={styles.itemWrapper}>
            <div className={styles.previewWrapper}>
              <div className={styles.squareBgWrapper}>
                <DisplayableSheet sheet={sheet} />
              </div>
            </div>
            <div className={styles.addonInfoWrapper}>
              <div className={styles.addonInfoInnerWrapper}>
                <p>{sheet.imageType.name}</p>
                <span>{currency(addonUnitPrice(sheet.addon, orderPackage)).format()}</span>
              </div>
              <IncrementalButton
                className={styles.btnsWrapper}
                onDecrement={() => handleDecrement(sheet.addon.id)}
                onIncrement={() => handleIncrement(sheet.addon.id)}
              />
            </div>
          </div>
        ))}
      </div>
      <div className={cn(styles.customizeBtnWrapper, { [styles.cancelBtn]: displayCancelButton })}>
        <div style={{ margin: '0 auto' }}>
          <Button disabled={isEmpty || isLoading} onClick={handleConfirm}>{`Select Backgrounds (${totalItems} items)`}</Button>
          {displayCancelButton && (
            <Button onClick={onCancelProps.onClick}>
              {onCancelProps.text || 'Continue'}
            </Button>
          )}
        </div>
      </div>
    </>
  );
}
